import axios from "axios";
import { $notify } from "@/toaster/ToasterPlugin";
// import router from "../../router/index";
const endpoint = "station";
export default {
  async fetchStations({ commit, state }) {
    let response;
    try {
      response = await axios.get(state.next_stations_url);
      commit("SET_SUCCESS", true);
      if (state.shouldAppend) {
        commit("SET_STATIONS", [...state.stations, ...response.data.data]);
      } else {
        commit("SET_STATIONS", response.data.data);
      }
      commit("SET_NEXT_STATIONS", response.data.links.next);
      commit("SET_SHOULD_APPEND", true);
    } catch (e) {
      commit("SET_ERRORS", e.response.data.errors);
    }
  },

  async createStation({ commit, state }, { data, message }) {
    try {
      let station = await axios.post(`owner/station/store-or-update`, {
        id: data.id,
        name: data.name,
        is_grounded: data.is_grounded,
        is_opened: data.is_opened,
        is_batteries: data.is_batteries,
        is_closed: data.is_closed,
        has_fence: data.hasFence,
        has_guestbook: data.hasGuestbook,
        has_guest_uniform: data.hasGuestUniform,
        has_motor_purge: data.hasMotorPurge,
        has_guest_bathroom: data.hasGuestBathroom,
        has_garage: data.hasGarage,
        description: data.address,
        lat: data.lat,
        lng: data.lng,
        governorate_id: data.governorate?.id,
        city_id: data.city?.id,
      });
      station = station.data;
      if (data.id) {
        commit(
          "SET_STATIONS",
          state.stations.map((existedStation) => {
            return existedStation.id === station.id ? station : existedStation;
          })
        );
      } else {
        commit("SET_STATIONS", [station, ...state.stations]);
      }
      $notify.success(message);
      commit("SET_SUCCESS", true);
      return station.id;
    } catch (e) {
      commit("SET_SUCCESS", false);
      commit("SET_ERRORS", e.response?.data?.errors);
      $notify.error(e.response?.data.message ?? e.response?.data);
      if (!e.response) {
        console.error(e);
      }
    }
  },

  async fetchStation({ commit }, id) {
    let response;
    try {
      response = await axios.get(`${endpoint}/${id}`);
      commit("SET_SUCCESS", true);
      commit("SET_STATION", response.data.data);
      commit("SET_DOCTOR", response.data.data.doctor);
      commit("SET_EMPLOYEES", response.data.data.employees);
      commit("SET_COOPS", response.data.data.coops);
    } catch (e) {
      commit("SET_ERRORS", e.response.data.errors);
    }
  },

  async destroyStation({ commit, state }, { id, message }) {
    try {
      await axios.post(`owner/station/destroy/${id}`);
      commit("SET_SUCCESS", true);
      commit(
        "SET_STATIONS",
        state.stations.filter((station) => {
          return station.id !== +id;
        })
      );
      $notify.success(message);
    } catch (e) {
      if (!e.response) console.error(e);
      commit("SET_SUCCESS", false);
      commit("SET_ERRORS", e.response?.data?.errors);
      $notify.error(e.response?.data);
    }
  },

  searchStation({ commit }, keywords) {
    commit("SET_NEXT_STATIONS", endpoint + "?keywords=" + keywords);
    commit("SET_STATIONS", []);
    commit("SET_SHOULD_APPEND", false);
    commit("SET_SEARCH_KEYWORD", keywords);
  },
};
